import { Indisponibilite } from './indisponibilite.model';
import { PlageActivite } from './plage-activite.model';
import { ActiviteInterne } from './activite-interne.model';
import { AgendaCrPartiel } from './agenda-cr.model';
import { Activite } from './activite.model';
import { OT } from './ot.model';

export interface AgendaJour {
  ots: OT[];
  activitesInternes: ActiviteInterne[];
  // Appelé absence sur les maquettes
  indispos: Indisponibilite[];
  astreintes: Activite[];
  // Appelé jour non travaillé sur les maquettes
  absences: Activite[];
  plageActivites: PlageActivite[];
  crs: AgendaCrPartiel[];
}

export interface AgendaJourOt {
  ots: OT[];
}

export interface AgendaJourActiviteInterne {
  activitesInternes: ActiviteInterne[];
}

export interface AgendaJourCrPartiel {
  crs: AgendaCrPartiel[];
}

export interface AgendaJourTempo {
  // Appelé absence sur les maquettes
  indispos: Indisponibilite[];
  deplacements: Activite[];
  astreintes: Activite[];
  // Appelé jour non travaillé sur les maquettes
  absences: Activite[];
  plageActivites: PlageActivite[];
}

export interface AgendaJourVM extends AgendaJour {
  isToday: boolean;
}

export enum VueJour {
  VueAgenda = 'vue-agenda',
  VueCartographie = 'vue-cartographie',
}

export enum Planning {
  Jour = 'jour',
  Mois = 'mois',
  Carte = 'carte',
}
